export default __webpack_public_path__ + "static/AISingapore-399477d5c8e02a03f38622cf8cd1044b.png";